module.exports = __webpack_public_path__ + "static/media/drag-icon.2caa0d7a.svg";